<template>
  <th @click="$emit('resort', field)"
      :class="[
        {
          sortable: field.sortable,
          sorted: !options.hidesorting && order === (field.sortable && field.sortable !== true ? field.sortable : field.id),
          primary: options.primaryKey == field.id,
          hidden: hiddenColumns && hiddenColumns.includes(field.id),
          pinned: !sticky && pinPointColumns.includes(field.id),
        },
        `size-${field.tdSize || 'default'}`,
        `th-${field.id}`
      ]"
      :style="sticky ? { width: width + 'px' } : { left: pinnedLeft(field) }">
    {{ $t(field.title) }}
    <span v-if="!options.hidesorting && order === (field.sortable && field.sortable !== true ? field.sortable : field.id)" class="sorted-block"></span>
    <span v-if="field.thhint"
          class="ml-1"
          v-b-popover.hover="$t(field.thhint)">
      <InfoSvg/>
    </span>
    <span v-if="!sticky && (canHideRows || options.fixedSizeTable)" class="datatable-toggle-column">
      <span v-if="canHideRows && hiddenColumns"
            @click.stop="$emit('toggle-column', field.id)">
        <EyeSvg v-b-tooltip.hover
                :title="field.label"
                class="svg-black svg-size-sm"
                v-if="hiddenColumns.includes(field.id)"/>
        <NoEyeSvg v-if="!hiddenColumns.includes(field.id)" class="svg-gray svg-size-sm"/>
      </span>
      <span v-if="options.fixedSizeTable"
            :class="{ pinned: pinPointColumns.includes(field.id) }"
            @click.stop="$emit('pin-column', field.id)">
        <PinSvg class="svg-size-sm svg-gray" v-if="pinPointColumns.includes(field.id)"/>
        <PinEmptySvg class="svg-size-sm svg-gray" v-else/>
      </span>
    </span>
  </th>
</template>

<script>
import InfoSvg from '@/assets/svg-vue/general/info.svg'
import EyeSvg from "@/assets/svg-vue/form/eye.svg.vue"
import NoEyeSvg from "@/assets/svg-vue/form/noeye.svg.vue"
import PinSvg from "@/assets/svg-vue/general/pin-bold.svg.vue"
import PinEmptySvg from "@/assets/svg-vue/general/pin-empty.svg.vue"

export default {
  name: "DataTableHeaderCell",
  components: {
    InfoSvg,
    EyeSvg,
    NoEyeSvg,
    PinSvg,
    PinEmptySvg,
  },
  emits: ['resort', 'toggle-column', 'pin-column'],
  props: {
    field: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    order: {
      type: String,
      default: null
    },
    hiddenColumns: {
      type: Array,
      default: () => []
    },
    pinPointColumns: {
      type: Array,
      default: () => []
    },
    canHideRows: {
      type: Boolean,
      default: false
    },
    pinnedLeft: {
      type: Function,
      default: () => null
    },
    sticky: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: null
    }
  }
}
</script>
